import iPhoneX from './iPhoneX.png';
import iPhoneX1 from './iPhoneX1.png';
import androidX1 from './androidX1.png';
import iPhoneX1Installer from './iPhoneX1-installer.png';
import androidX1Installer from './androidX1-installer.png';
import downloadIOS from './download-ios.png';
import downloadAndroid from './download-android.png';

export { iPhoneX, iPhoneX1, androidX1, iPhoneX1Installer, androidX1Installer, downloadIOS, downloadAndroid };
